import * as styles from './styles'
import { TagVariant } from './styles'

type TagProps = {
  variant?: TagVariant
  children: React.ReactNode
  className?: string
}

const ColoredTag = ({ variant = 'blue', children, className }: TagProps) => {
  return (
    <styles.Tag $tagVariant={variant} className={className}>
      {children}
    </styles.Tag>
  )
}

export default ColoredTag
